import { render, staticRenderFns } from "./ChartTpl.vue?vue&type=template&id=8734bbb4&scoped=true&"
import script from "./ChartTpl.vue?vue&type=script&lang=js&"
export * from "./ChartTpl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8734bbb4",
  null
  
)

export default component.exports